(ns app.front.ui.v2.mobile-bottom-action-bar
  (:require ["@carbon/icons-react/es/close/24" :default Close24]
            [app.front.ui.action-buttons :as action-buttons]
            [app.front.ui.contextual-menu :as ctx-menu]
            [core.util.util :as util]
            [potpuri.core :as p]))

(defn- menu-action
  "Converts an action-button map to a ctx-menu action with full-width mobile styling."
  [action]
  (p/assoc-if {:title      (:text action)
               :class-name (str "min-h-0 px-9 py-6 text-cloudpermit-purple bg-white border-0 "
                                "rounded-none uppercase place-content-start w-full max-w-none "
                                "text-left text-sm hover:bg-white")}
              :href (:href action)
              :disabled? (:disabled? action)
              :on-click (:on-click action)))

(defn- show-leading-menu?
  [leading-actions primary-actions]
  (< 2 (+ (count leading-actions) (count primary-actions))))

(defn- leading-menu
  [{:keys [data-cy leading-actions overflow-menu-data-cy tr]}]
  [ctx-menu/menu
   (mapv (fn [action] {:actions [(menu-action action)]}) leading-actions)
   (util/mmap {:content-class        "bg-white"
               :data-cy              (or overflow-menu-data-cy (some-> data-cy (str "-overflow-menu")))
               :align                "left"
               :toggle-props         {:class "bx--btn bx--btn--tertiary bx--btn--sm h-10 w-10 p-0 justify-center"}
               :close-toggle-element [:> Close24 {}]
               ;; Open upward, full viewport width. The toggle sits in the fixed
               ;; mobile footer, so the default downward menu would fall off the viewport.
               :options-props        {:style {:top        "auto"
                                              :bottom     "calc(100% + 0.5rem)"
                                              ;; Negate parent p-4 so the menu spans full viewport width.
                                              :left       "-1rem"
                                              :width      "100vw"
                                              :max-width  "100vw"
                                              :max-height "none"}
                                      :class "bg-white border-t border-b border-solid border-gray-400"}}
              tr)])

(defn mobile-bottom-action-bar
  "Fixed mobile bottom action bar with optional leading actions.

   `leading-actions` are secondary actions shown on the left. A single leading action
   is rendered as a button only when there is one primary action; otherwise leading
   actions are moved into an overflow menu to reserve space for primary/navigation actions."
  [{:keys [data-cy leading-actions overflow-menu-data-cy primary-actions tr]}]
  (let [leading-actions (->> leading-actions (remove nil?) vec)
        primary-actions (->> primary-actions (remove nil?) vec)]
    [:div {:class   (str "fixed bottom-0 left-0 right-0 z-40 p-4 flex flex-row items-center "
                         "justify-between bg-white border-t border-solid border-gray-400 shadow-lg")
           :data-cy data-cy}
     (when (seq leading-actions)
       [:div
        (if (show-leading-menu? leading-actions primary-actions)
          [leading-menu (util/mmap data-cy leading-actions overflow-menu-data-cy tr)]
          [action-buttons/action-buttons {:buttons leading-actions}])])
     [:div.ml-auto
      [action-buttons/action-buttons {:buttons primary-actions}]]]))
